import { IPromo } from '../../types/newbuilding/promos';

export const getPromoSubtitle = (promo?: IPromo, blackFridayTopPromoSubtitle?: string) => {
  if (blackFridayTopPromoSubtitle && promo?.isBlackFriday) {
    return blackFridayTopPromoSubtitle;
  }

  return promo?.subtitle;
};
